export const generateTestId = (label: string) => label.toLowerCase().split(' ').join('-');
